import { LinkCall, linkConfig } from "../../share/link/type"
/**
 * 处理多个init DSL时，传入的cloud API config
 * @param list
 * @param api
 * @returns
 */
export function getLinkConfig(list: linkConfig[], api: string) {
  if (!list?.length) return null
  if (list.length === 1) {
    return list[0].getConfig(api)
  }
  const config = list.find((fn: linkConfig) => fn?.getConfig!(api))
  return config?.getConfig(api) || null
}

export function pageDestoryListener() { }

export const link: LinkCall = {
  configFn: [],
  sdk: function <T>(): Promise<T> {
    throw new Error("Function not implemented.")
  },
  init(cfg: linkConfig) {
    (link.configFn as linkConfig[]).push(cfg)
  },
  addListener: function (
    type: "scanner",
    fn: (data: unknown, err: unknown) => void
  ): void {
    throw new Error("Function not implemented.")
  },
  removeLastListener: function (type: "scanner"): void {
    throw new Error("Function not implemented.")
  },
  listener: function (): Promise<string> {
    throw new Error("Function not implemented.")
  },
  remove: function (key: string): Promise<void> {
    throw new Error("Function not implemented.")
  },

}
